import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { UnauthGuard } from 'app/core/guards/unauth.guard';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.forgetPassword),
      component: ForgetPasswordComponent,
      canActivate: [UnauthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class ForgetPasswordRoutingModule { }
